module.exports = "/assets/landing-dw/how-it-works/arrow@2x.png?7LzP1lU";